<div *ngIf="loading" class="loading-container">
	<mat-spinner></mat-spinner>
</div>

<div *ngIf="error" class="error-message">
	{{ error }}
</div>

<div class="script-list-container">
	<!-- Toolbar -->
	<div class="header-toolbar">
		<h1 class="page-title">Formly Builder</h1>
		<button mat-button class="add-button" (click)="addNewScript()"><mat-icon>add</mat-icon> Add Script</button>
	</div>

	<!-- Filters -->
	<div class="filters">
		<mat-form-field appearance="outline" class="tag-filter">
			<mat-label>Filter by Tags</mat-label>
			<mat-select [(ngModel)]="selectedTags" (selectionChange)="applyFilters()" multiple>
				<!-- List of all tags -->
				<mat-option *ngFor="let tag of tagKeys" [value]="tag">
					{{ tag }}
				</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="search-field">
			<mat-label>Search</mat-label>
			<input
				matInput
				[placeholder]="searchPlaceholder"
				[(ngModel)]="searchTerm"
				(focus)="searchPlaceholder = 'Search scripts'"
				(blur)="searchPlaceholder = ''"
				(ngModelChange)="applyFilters()"
			/>
			<!-- Clear button appears only if searchTerm is not empty -->
			<button mat-icon-button matIconSuffix *ngIf="searchTerm" (click)="clearSearch()">
				<mat-icon>close</mat-icon>
			</button>
			<!-- Conditionally display the search icon when searchTerm is empty -->
			<button mat-icon-button matIconSuffix *ngIf="!searchTerm" tabindex="-1">
				<mat-icon>search</mat-icon>
			</button>
		</mat-form-field>
	</div>

	<!-- Card Grid -->
	<div class="script-cards">
		<mat-card *ngFor="let script of paginatedScripts" class="script-card">
			<mat-card-header class="script-header">
				<mat-icon mat-card-avatar>description</mat-icon>
				<mat-card-title>{{ script.scriptId }} - {{ script.name }}</mat-card-title>

				<!-- Top-Right Menu -->
				<div class="card-menu">
					<button
						mat-icon-button
						[matMenuTriggerFor]="menu"
						(click)="setActiveScript(script)"
						matTooltip="More Options"
					>
						<mat-icon class="menu-icon">more_vert</mat-icon>
					</button>
				</div>
			</mat-card-header>
			<mat-card-content>
				<p class="script-desc">{{ script.description }}</p>

				<!-- divider -->
				<mat-divider></mat-divider>

				<!-- Last modified metadata from git -->
				<p *ngIf="script.modifiedBy"><strong>Modified By:</strong> {{ script.modifiedBy }}</p>
				<p *ngIf="script.modifiedDate"><strong>Modified:</strong> {{ script.modifiedDate | date: 'medium' }}</p>

				<!-- Display Tags if available -->
				<ng-container *ngIf="script.tags && script.tags.length > 0">
					<mat-chip-set>
						<mat-chip *ngFor="let tag of script.tags">{{ tag }}</mat-chip>
					</mat-chip-set>
				</ng-container>
			</mat-card-content>

			<!-- divider -->
			<mat-divider></mat-divider>

			<mat-card-actions>
				<!-- Router Link for "Edit" -->
				<a
					mat-button
					class="edit-script-btn"
					[routerLink]="['/formly/builder', script.scriptId]"
					matTooltip="Edit Script"
				>
					<mat-icon>edit</mat-icon>
					EDIT
				</a>
				<button
					mat-button
					class="delete-script-btn"
					(click)="deleteScript(script.scriptId)"
					aria-label="Delete script"
				>
					<mat-icon>delete</mat-icon>
					Delete
				</button>
			</mat-card-actions>
		</mat-card>
	</div>

	<!-- Shared Menu -->
	<mat-menu #menu="matMenu">
		<button mat-menu-item (click)="addTagToScript(activeScript)" matTooltip="Add Tag">
			<mat-icon>add_circle_outline</mat-icon>
			<span>Add Tag</span>
		</button>
		<button mat-menu-item (click)="duplicateScript(activeScript)" matTooltip="Duplicate Script">
			<mat-icon>content_copy</mat-icon>
			<span>Duplicate Script</span>
		</button>
	</mat-menu>

	<!-- Pagination -->
	<mat-paginator
		[pageSizeOptions]="[5, 10, 25, 100]"
		[length]="filteredScripts.length"
		[pageSize]="pageSize"
		[pageIndex]="currentPage"
		(page)="onPageChange($event)"
		aria-label="Select page"
	>
	</mat-paginator>
</div>
